import { ApiResponse } from "../types/common";
import { ProductOffersResponse } from "../types/products";

import apiClient from "./apiClient";

export const getProductOffers = (
  productId: string,
  retailer: string
): Promise<ApiResponse<ProductOffersResponse>> => {
  return apiClient
    .get(`/Products/${productId}/offers`, {
      params: { retailer },
    })
    .then((response) => response.data);
};
